import { useContext } from 'react';
import { ProductContext } from "./ProductCard";

import styles from '../styles/styles.module.css'


export interface Props {
    className?: string
    existencia?: string,
    activeClass?: string;
    style?: React.CSSProperties
}

export const ProductExistencia = ({ existencia, className, style }: Props) => {

    const { product } = useContext(ProductContext)
    return (
        <span
            className={`${styles.productDescription} ${className}`}
            style={style}
        >
            {existencia ? existencia : product.existencia}
        </span>
    );
}